module.exports = __webpack_public_path__ + "img/phone.78acc23a.png";